import { render, staticRenderFns } from "./NewNeedsPopup.vue?vue&type=template&id=2f214cc0&"
import script from "./NewNeedsPopup.vue?vue&type=script&lang=js&"
export * from "./NewNeedsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports